import React from "react";
import { AnalyticsHubConstants } from "./AnalyticsHubConstants";
import "./AnalyticsHub.scss";

const AnalyticsHub: React.FC = () => {
    const { analyticsHub } = AnalyticsHubConstants;

    return (
        <section className="analytics-hub">
            <div className="analytics-hub-container">
                <div className="analytics-hub-card">
                    {/* Content */}
                    <div className="analytics-hub-content">
                        <h2 className="analytics-hub-title">
                            {analyticsHub.title}
                        </h2>
                        <p className="analytics-hub-description">
                            {analyticsHub.description}
                        </p>

                        {/* Statistics */}
                        <div className="analytics-hub-stats">
                            {analyticsHub.stats.map((stat, index) => (
                                <div key={index} className="analytics-hub-stat-item">
                                    <div className={`stat-value stat-value-${stat.color}`}>
                                        {stat.value}
                                    </div>
                                    <div className="stat-label">
                                        {stat.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AnalyticsHub;

